import styles from './Header.css';
import Login from './Login';

import { translations } from './../i18/translations.js';
import LanguageSelector from './LanguageSelector';

function Header( { user, onUserChange, lang, onLangChange, setGrowlMessage }) {

    return (
            <>
            <div className="header-container">
                <div className="login-row d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <LanguageSelector lang={lang} onLangChange={onLangChange} />
                    </div>
            
                    <div className="text-center flex-grow-1">
                        {user && <p className="m-0">{translations[lang].welcome}, {user.fullname}!</p>}
                    </div>
            
                    <div className="d-flex align-items-center">
                        <Login user={user} onUserChange={onUserChange} lang={lang} setGrowlMessage={setGrowlMessage} />
                    </div>
                </div>
            
            </div>
            
            <div className="header-container-logo-title">
                <div className="header-container-title">{translations[lang].mbkegy}</div>
            </div>
            </>
            );
}

export default Header